import axios from 'api/axios'

const getNewClientUserPassword = async (userID: string): Promise<string> => {
	const { data } = await axios.post<string>(
		`/admin/update-password/admin/reset`,
		{
			admin: userID,
		}
	)
	return data
}

export default getNewClientUserPassword
